import React, { FC, useEffect } from 'react'

import { applyFreeShippingTagToItem } from '@lojinha/cms-strapi/src/components/display/free-shipping-tag'
import { useLojinhaContext } from '@lojinha/context'
import { useFreeShipping } from '@lojinha/location/src/free-shipping/free-shipping.hooks'
import { Router } from '../../../../router'
import { MarketableDetails } from '../../../modules/marketable-details'
import { LoadingSummary } from '../../../modules/marketable-details/summary/loading'
import { NoPageComponent } from '../../../modules/page-content/no-page.ui'
import { DisplayItems } from '../../../modules/page-content/page-content.types'
import { useKit } from './hook'

export const KitSlug: FC = () => {
  const { loading, data } = useKit()
  const {
    freeShippingValue,
    setFreeShippingValue,
    setLoadingFreeShippingValue,
  } = useLojinhaContext()
  const { getFreeShippingValue } = useFreeShipping({
    setFreeShippingValue,
    setLoadingFreeShippingValue,
  })

  useEffect(() => {
    if (!freeShippingValue) {
      getFreeShippingValue()
    }
  }, [freeShippingValue]) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return <LoadingSummary />
  }
  if (!data) {
    return <NoPageComponent onButtonClick={() => Router.back()} />
  }

  let item = data.kitBySlug as DisplayItems

  if (freeShippingValue) {
    item = applyFreeShippingTagToItem(data.kitBySlug, freeShippingValue)
  }

  return <MarketableDetails item={item} />
}
